/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssociateFilesWithApplicationFormRequest,
  ProblemDetails,
  UploadedFileDto,
} from '../models/index';
import {
    AssociateFilesWithApplicationFormRequestFromJSON,
    AssociateFilesWithApplicationFormRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UploadedFileDtoFromJSON,
    UploadedFileDtoToJSON,
} from '../models/index';

export interface AssociateFilesWithApplicationFormOperationRequest {
    applicationFormId: string;
    associateFilesWithApplicationFormRequest: AssociateFilesWithApplicationFormRequest;
}

export interface DeleteFileRequest {
    id: string;
}

export interface DownloadFileContentRequest {
    id: string;
    inline?: boolean;
}

export interface GetFileByIdRequest {
    id: string;
}

export interface GetFilesByApplicationFormRequest {
    applicationFormId: string;
    formElementReference?: string;
}

export interface UploadFileRequest {
    file: Blob;
    formElementReference: string;
    organizationId?: string | null;
    applicationFormId?: string | null;
}

/**
 * 
 */
export class FileApi extends runtime.BaseAPI {

    /**
     * Associate files with an application form
     */
    async associateFilesWithApplicationFormRaw(requestParameters: AssociateFilesWithApplicationFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling associateFilesWithApplicationForm().'
            );
        }

        if (requestParameters['associateFilesWithApplicationFormRequest'] == null) {
            throw new runtime.RequiredError(
                'associateFilesWithApplicationFormRequest',
                'Required parameter "associateFilesWithApplicationFormRequest" was null or undefined when calling associateFilesWithApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/files`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssociateFilesWithApplicationFormRequestToJSON(requestParameters['associateFilesWithApplicationFormRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Associate files with an application form
     */
    async associateFilesWithApplicationForm(requestParameters: AssociateFilesWithApplicationFormOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.associateFilesWithApplicationFormRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a file
     */
    async deleteFileRaw(requestParameters: DeleteFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a file
     */
    async deleteFile(requestParameters: DeleteFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFileRaw(requestParameters, initOverrides);
    }

    /**
     * Download file content
     */
    async downloadFileContentRaw(requestParameters: DownloadFileContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling downloadFileContent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['inline'] != null) {
            queryParameters['inline'] = requestParameters['inline'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/files/{id}/content`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download file content
     */
    async downloadFileContent(requestParameters: DownloadFileContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadFileContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get file metadata by ID
     */
    async getFileByIdRaw(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFileById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/files/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileDtoFromJSON(jsonValue));
    }

    /**
     * Get file metadata by ID
     */
    async getFileById(requestParameters: GetFileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileDto> {
        const response = await this.getFileByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all files for an application form
     */
    async getFilesByApplicationFormRaw(requestParameters: GetFilesByApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UploadedFileDto>>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getFilesByApplicationForm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['formElementReference'] != null) {
            queryParameters['formElementReference'] = requestParameters['formElementReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/files`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UploadedFileDtoFromJSON));
    }

    /**
     * Get all files for an application form
     */
    async getFilesByApplicationForm(requestParameters: GetFilesByApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UploadedFileDto>> {
        const response = await this.getFilesByApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a new file for a form element
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileDto>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadFile().'
            );
        }

        if (requestParameters['formElementReference'] == null) {
            throw new runtime.RequiredError(
                'formElementReference',
                'Required parameter "formElementReference" was null or undefined when calling uploadFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['organizationId'] != null) {
            formParams.append('organizationId', requestParameters['organizationId'] as any);
        }

        if (requestParameters['applicationFormId'] != null) {
            formParams.append('applicationFormId', requestParameters['applicationFormId'] as any);
        }

        if (requestParameters['formElementReference'] != null) {
            formParams.append('formElementReference', requestParameters['formElementReference'] as any);
        }

        const response = await this.request({
            path: `/files`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileDtoFromJSON(jsonValue));
    }

    /**
     * Upload a new file for a form element
     */
    async uploadFile(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileDto> {
        const response = await this.uploadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
